export const PREDEF_ANSWERS_ROUTE = {
	GET_LIST: '/api/predef-answers-list',
	CREATE: '/api/predef-answers-create',
	UPDATE: '/api/predef-answers-update',
	DELETE: '/api/predef-answers-delete',
};

export const MAX_PREDEF_ANSWER_LENGTH = 300;
